import { SportActivityQueries } from './queries';
import { SportActivityMutations } from './mutations';

export const SportActivity = {
  queries: SportActivityQueries,
  mutations: SportActivityMutations,
};
